/**
 * @generated SignedSource<<92b973d936036156d5856f358bdd784a>>
 * @relayHash ccc2fbd0a3839f1ff09007af98d695a2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID be5bea6aea08c11bce374ca854555fd7e14aef36a2086e6c6dc917350319a138

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraVersionUpdateApproverDescriptionInput = {
  approverId: string;
  description?: string | null | undefined;
};
export type approvalDescription_softwareReleasesApproversMutation$variables = {
  input: JiraVersionUpdateApproverDescriptionInput;
};
export type approvalDescription_softwareReleasesApproversMutation$data = {
  readonly jira: {
    readonly updateJiraVersionApproverDescription: {
      readonly approver: {
        readonly description: string | null | undefined;
        readonly id: string;
      } | null | undefined;
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type approvalDescription_softwareReleasesApproversMutation$rawResponse = {
  readonly jira: {
    readonly updateJiraVersionApproverDescription: {
      readonly approver: {
        readonly description: string | null | undefined;
        readonly id: string;
      } | null | undefined;
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type approvalDescription_softwareReleasesApproversMutation = {
  rawResponse: approvalDescription_softwareReleasesApproversMutation$rawResponse;
  response: approvalDescription_softwareReleasesApproversMutation$data;
  variables: approvalDescription_softwareReleasesApproversMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "JiraVersionUpdateApproverDescriptionPayload",
        "kind": "LinkedField",
        "name": "updateJiraVersionApproverDescription",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "JiraVersionApprover",
            "kind": "LinkedField",
            "name": "approver",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "description"
              }
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "approvalDescription_softwareReleasesApproversMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "approvalDescription_softwareReleasesApproversMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "be5bea6aea08c11bce374ca854555fd7e14aef36a2086e6c6dc917350319a138",
    "metadata": {},
    "name": "approvalDescription_softwareReleasesApproversMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "3552fa1fc260ed118615ad832c35b8ff";

export default node;
